export enum EventVisibilityModeModel {
  Everyone = 0,
  Restricted = 1,
  Subscribers = 2,
  MyContactList = 3
}